import React from 'react';
import { Link } from 'react-router-dom';
import { Home, FolderKanban, Calculator, User, LayoutGrid } from 'lucide-react';

const TABS = [
  { to: '/dashboard', label: 'Hem', icon: Home, match: (p) => p === '/dashboard', id: 'home' },
  { to: '/dashboard/projects', label: 'Projekt', icon: FolderKanban, match: (p) => p.startsWith('/dashboard/projects'), id: 'projects' },
  { to: '/dashboard/projects?new=1', label: 'Kalkylator', icon: Calculator, match: () => false, id: 'calc' },
  { to: '/dashboard/settings', label: 'Profil', icon: User, match: (p) => p.startsWith('/dashboard/settings'), id: 'profile' },
];

export const MobileNav = ({ pathname, onMore }) => (
  <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur-xl border-t border-stone-200 mobile-bottom-nav" data-testid="mobile-bottom-nav">
    <div className="grid grid-cols-5 h-16">
      {TABS.map((t) => {
        const Icon = t.icon;
        const active = t.match(pathname);
        return (
          <Link key={t.id} to={t.to} data-testid={`mobile-nav-${t.id}`}
            className={`flex flex-col items-center justify-center gap-1 text-[10.5px] font-medium ${active ? 'text-[#F26B1F]' : 'text-stone-500'}`}>
            <Icon size={20} strokeWidth={active ? 2.3 : 1.8} />{t.label}
          </Link>
        );
      })}
      <button onClick={onMore} data-testid="mobile-nav-more" className="flex flex-col items-center justify-center gap-1 text-[10.5px] font-medium text-stone-500">
        <LayoutGrid size={20} strokeWidth={1.8} />Mer
      </button>
    </div>
  </nav>
);
